var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { BottomSheet as ReactSpringBottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';
import { BottomSheetContent, BottomSheetHeader, FakeOverlay } from './subcomponents';
var BottomSheet = function (_a) {
    var children = _a.children, isOpen = _a.isOpen, onDismiss = _a.onDismiss;
    return (_jsxs(_Fragment, { children: [_jsxs(ReactSpringBottomSheet, __assign({ "data-body-scroll-lock-ignore": "true", open: isOpen, onDismiss: onDismiss, blocking: false, snapPoints: function () { return 586; }, style: {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore: https://github.com/stipsan/react-spring-bottom-sheet#customizing-the-css
                    '--rsbs-bg': '#34657f',
                    '--rsbs-handle-bg': 'white',
                    zIndex: 1,
                    position: 'relative'
                } }, { children: [_jsx(BottomSheetHeader, {}), _jsx(BottomSheetContent, { children: children })] })), isOpen && (_jsx(FakeOverlay, { id: "fake-overlay", onClick: onDismiss, "data-type": "rewards certificate", "data-reason": "close", "data-object": "button", "data-analytics": "clicktrackingevent" }))] }));
};
export default BottomSheet;
